import React, { useEffect } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { permissions } from '../../Store/reducers/PermissionsReducer';

function PermissionGuard({ Component, type } ) {
    const history = useHistory();
    const permission = useSelector(permissions);
    useEffect(() => {
        if (permission && permission.length && !permission.includes(type)) {
            history.push('/admin/users');
        }
        //eslint-disable-next-line
    }, [permission]);

    return <Component />;
}
export default withRouter(PermissionGuard);